import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface OpenRoutesIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export const OpenRoutesIcon = ({ color = `#E29C0C`, style = {}, ...props }: OpenRoutesIconProps) => {
  const { width = `20px`, height = `20px` } = style;
  return (
    <SvgIcon {...props} viewBox="0 0 21 20" style={{ width, height, ...style }}>
      <g>
        <rect x="0.169922" width={width} height={height} rx="4" fill={color} />
        <path
          d="M13.0289 11.9085V9.48305C13.0289 7.99381 12.2334 6.74711 10.846 6.41725V6.08738C10.846 5.68475 10.5161 5.35974 10.1135 5.35974C9.71088 5.35974 9.39072 5.68475 9.39072 6.08738V6.41725C7.9985 6.74711 7.20779 7.98896 7.20779 9.48305V11.9085L6.57717 12.5343C6.27156 12.8399 6.485 13.3638 6.91674 13.3638H13.3054C13.7372 13.3638 13.9555 12.8399 13.6499 12.5343L13.0289 11.9085ZM10.1135 14.8191C10.6471 14.8191 11.0837 14.3825 11.0837 13.8489H9.14332C9.14332 14.3825 9.57506 14.8191 10.1135 14.8191ZM7.58132 6.4415C7.78506 6.25717 7.78991 5.94186 7.59587 5.74782C7.41153 5.56348 7.11077 5.55863 6.92159 5.73812C6.09207 6.49486 5.51966 7.52326 5.33533 8.67779C5.29167 8.9737 5.51966 9.2405 5.82042 9.2405C6.05327 9.2405 6.25701 9.07072 6.29581 8.83787C6.44134 7.89679 6.90703 7.05757 7.58132 6.4415ZM13.32 5.73812C13.126 5.55863 12.8252 5.56348 12.6409 5.74782C12.4468 5.94186 12.4565 6.25232 12.6554 6.43665C13.3248 7.05272 13.7954 7.89194 13.9409 8.83302C13.9749 9.06587 14.1786 9.23565 14.4163 9.23565C14.7122 9.23565 14.9451 8.96885 14.8965 8.67294C14.7122 7.52326 14.1447 6.49971 13.32 5.73812Z"
          fill={RoutalPalette.white}
        />
      </g>
    </SvgIcon>
  );
};
